<title>{{ testCreditCardsPage.htmlTitle }}</title>
<app-section [sections]="testCreditCardsPage.sections"></app-section>
<app-api-reference-note-section [noteSections]="testCreditCardsPage.noteSections"></app-api-reference-note-section>
<app-api-reference-table-section class="countryTitleWithTable" [tableSections]="testCreditCardsPage.tableSections" [testingYourBuildPage]="true" [isDefault]="false"></app-api-reference-table-section>
